import { cva } from "class-variance-authority";

export const tagContainerCva = cva("inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap w-fit", {
  variants: {
    variant: {
      "is-primary": "bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300",
      "is-secondary": "bg-secondary-100 dark:bg-secondary-900/30 text-secondary-700 dark:text-secondary-300",
      "is-info": "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300",
      "is-warning": "bg-warning-100 dark:bg-warning-900/30 text-warning-700 dark:text-warning-300",
      "is-danger": "bg-danger-100 dark:bg-danger-900/30 text-danger-700 dark:text-danger-300",
      "is-success": "bg-success-100 dark:bg-success-900/30 text-success-700 dark:text-success-300",
      "is-gray": "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300",
      "is-subtle": "bg-gray-100 dark:bg-dark-600 text-gray-500 dark:text-gray-400 rounded",
      "is-text-color": "bg-gray-300 dark:bg-dark-800 text-gray-800 dark:text-white",
    },
    size: {
      "extra-small": "text-[10px] px-2 py-0.5",
      "small": "text-xs px-2.5 py-1",
      "medium": "text-sm px-3 py-1.5",
      "large": "text-base px-4 py-2",
    },
    cursor: {
      true: "cursor-pointer",
      false: null,
    },
    selectable: {
      true: "cursor-pointer",
      false: null,
    },
    checked: {
      true: "bg-primary-400 text-white",
      false: null,
    },
  },
  defaultVariants: {
    variant: "is-primary",
    size: "small",
    cursor: false,
    selectable: false,
    checked: false,
  },
});

export const tagIconCva = cva("flex items-center justify-center shrink-0", {
  variants: {},
  defaultVariants: {},
});

export const tagTextCva = cva("flex-1 overflow-hidden text-ellipsis whitespace-nowrap", {
  variants: {},
  defaultVariants: {},
});

export const tagCloseCva = cva("flex items-center justify-center cursor-pointer transition-transform duration-250 hover:rotate-90 active:scale-110", {
  variants: {
    disabled: {
      true: "opacity-50 cursor-not-allowed",
      false: null,
    },
  },
  defaultVariants: {
    disabled: false,
  },
});
